import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M26.0612 23.9388C26.343 24.2205 26.5013 24.6027 26.5013 25.0013C26.5013 25.3998 26.343 25.782 26.0612 26.0638C25.7794 26.3455 25.3972 26.5039 24.9987 26.5039C24.6002 26.5039 24.218 26.3455 23.9362 26.0638L15.9999 18.125L8.0612 26.0613C7.7794 26.343 7.39721 26.5014 6.9987 26.5014C6.60018 26.5014 6.21799 26.343 5.9362 26.0613C5.6544 25.7795 5.49609 25.3973 5.49609 24.9988C5.49609 24.6002 5.6544 24.218 5.9362 23.9363L13.8749 16L5.9387 8.06125C5.6569 7.77946 5.49859 7.39727 5.49859 6.99876C5.49859 6.60024 5.6569 6.21805 5.9387 5.93626C6.22049 5.65446 6.60268 5.49615 7.0012 5.49615C7.39971 5.49615 7.7819 5.65446 8.0637 5.93626L15.9999 13.875L23.9387 5.93501C24.2205 5.65321 24.6027 5.4949 25.0012 5.4949C25.3997 5.4949 25.7819 5.65321 26.0637 5.93501C26.3455 6.2168 26.5038 6.59899 26.5038 6.99751C26.5038 7.39602 26.3455 7.77821 26.0637 8.06001L18.1249 16L26.0612 23.9388Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconClose'

export const IconClose = memo(themed(Icon))
